<template>

  <div class="mx-sm-1 mt-0">
    <div class="page-header">
      <h1 class="page-title fw-bold">{{ $t('project.title') }}</h1>
    </div>

    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h3 class="card-title fw-bold mb-0">{{ $t('project.listTitle') }}</h3>
        <div class="card-options d-flex gap-2">
          <button
              v-if="canCreate"
              class="btn btn-outline-success btn-sm"
              @click="$emit('operation', { type: Operations.CREATE })"
          >
            <i class="fe fe-plus-circle me-1"></i> {{ $t('button.add') }}
          </button>
<!--          <button class="btn btn-outline-info btn-sm" @click="exportCSV">-->
<!--            <i class="fe fe-download me-1"></i> {{ $t('button.export') }}-->
<!--          </button>-->
<!--          <button class="btn btn-outline-primary btn-sm" @click="triggerFileInput">-->
<!--            <i class="fe fe-upload me-1"></i> {{ $t('button.import') }}-->
<!--          </button>-->
<!--          <input type="file" ref="fileInput" class="d-none" accept=".xlsx, .xls" @change="importCSV" />-->
        </div>
      </div>

      <div class="card-body">
        <TableWithFilters
            :columns="columns"
            :filterableFields="[]"
            @row-click="onRowClick"
            :items="items"
            @edit="item => $emit('edit', item.code)"
            @view="item => $emit('view', item.code)"
        >
          <template #cell-code="{ item }">
            <strong>{{ item.code }}</strong>
          </template>
          <template #cell-label="{ item }">
            {{ item.label }}
          </template>
          <template #cell-description="{ item }">
            {{ item.description }}
          </template>
        </TableWithFilters>
      </div>
    </div>


  </div>
</template>

<script>


  import TableWithFilters from "../../../../components/TableWithFilters.vue";
  import {Operations, Roles} from "../../../../helpers/roles";

  export default {
    name: 'ProjectTable',
    components: {TableWithFilters },
    props: {
      items: { type: Array, default: () => [] },
    },
    data() {
      return {
        columns: [
          { key: 'code', label: 'Code' },
          { key: 'label', label: 'Libellé' },
          { key: 'description', label: 'Description' },
        ],
      };
    },
    computed: {
      Operations() {
        return Operations
      },
      canCreate() {
        return this.$can(Roles.PROJET_CREATE);
      }
    },
    methods: {
      onRowClick(item) {
        this.$emit('operation', {
          type: Operations.VIEW,
          payload: item.code
        });
      }
    }

  };
</script>
